import { DataGrid, GridColumnsConfigProvider } from '@finbeat/react-toolkit';
import DataTimeText from 'components/Common/DataTime';
import Money from 'components/Common/Money';
import { PaymentCovers } from 'models/api/payment';
import DataGridProp from 'models/dataGridProp';
import { Trans, useTranslation } from 'react-i18next';

type PaymentCoversTableType = PaymentCovers & DataGridProp;

const PaymentCoversTable = ({ covers }: { covers: PaymentCovers[] }) => {
    useTranslation();
    return (
        <GridColumnsConfigProvider<PaymentCoversTableType>
            storagePath="payment-covers-grid"
            initColumns={[
                {
                    key: 'loanAccountNo',
                    name: <Trans i18nKey="BackOfficeService" />,
                    cellClass: 'base-data-grid__normal-line-height',
                    formatter: ({ row }) => (
                        <>
                            <div>{row.loanServiceName}</div>
                            <small className="text-muted">{row.service}</small>
                        </>
                    ),
                },
                {
                    key: 'amount',
                    name: <Trans i18nKey="BackOfficeAccrualAmount" />,
                    cellClass: 'base-data-grid__normal-line-height',
                    formatter: ({ row }) => (
                        <>
                            <div>
                                <Money value={row.calcAmount} />
                            </div>
                            <small className="text-muted">
                                <DataTimeText value={row.fd} />
                                {' - '}
                                <DataTimeText value={row.td} />
                            </small>
                        </>
                    ),
                },
                {
                    key: 'unallocatedAmount',
                    name: <Trans i18nKey="BackOfficeCoverageAmount" />,
                    cellClass: 'base-data-grid__normal-line-height',
                    formatter: ({ row }) => (
                        <>
                            <div>
                                <Money value={row.coveredAmount} />
                            </div>
                            <small className="text-muted">
                                <DataTimeText value={row.coveredDt} />
                            </small>
                        </>
                    ),
                },
            ]}
        >
            <DataGrid<PaymentCoversTableType>
                rows={covers}
                lineHeight={45}
                reactDataGreedProps={{
                    defaultColumnOptions: {
                        sortable: true,
                        resizable: true,
                    },
                }}
                blockSize={45 + covers.length * 45}
                minBlockSize={90}
            />
        </GridColumnsConfigProvider>
    );
};

export default PaymentCoversTable;
